import axios from 'axios'
import {toast} from 'react-toastify'
import {logError} from './errorLog'
import {isLogSenderEndpoint} from './logSender'

const posUrl = process.env.REACT_APP_POS_API_URL;

let isRedirectingTo401 = false;
// setApi() se zove vise puta (boot, prijava, promjena blagajne). Interceptor se pritom
// registrirao svaki put, pa je jedan neuspio zahtjev zavrsavao u dijagnostici dvaput i
// vise — broj "gresaka" u kritičnom mailu bio je umnozak broja prijava, ne stvarnih kvarova.
let responseInterceptorRegistered = false;

// Kodovi koje backend vraca za ocekivane ishode, ne za kvarove.
const EXPECTED_ERROR_CODES = new Set(['NOT_CANCELLABLE'])

export const setApi = () => {

    window.axios = axios
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    window.axios.defaults.baseURL = posUrl

    let invoiceDevice = {}

    if (localStorage.getItem('token')) {
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`
        window.axios.defaults.headers.common['X-Authorization'] = `Bearer ${localStorage.getItem('token')}`
    }

    if (localStorage.getItem('invoiceDevice')) {
        invoiceDevice = JSON.parse(localStorage.getItem('invoiceDevice'))
        window.axios.defaults.params = {}
        window.axios.defaults.params['invoice_device_id'] = invoiceDevice.id
    }

    if (localStorage.getItem('user_id')) {
        var userId = localStorage.getItem('user_id');
        window.axios.defaults.headers.common['X-User-Id'] = userId;
    }

    if (!responseInterceptorRegistered) {
        responseInterceptorRegistered = true
        window.axios.interceptors.response.use(
            (response) => response,
            (error) => {
                try {
                    const cfg = error?.config || {}
                    const url = cfg.url || ''
                    const method = (cfg.method || '').toUpperCase()
                    const status = error?.response?.status
                    // Poslovni ishodi koje poslužitelj javlja ne-2xx statusom, a nisu kvar
                    // (npr. terminal vise ne da otkazati naplatu) ne idu u dijagnostiku kao greske.
                    const expected = EXPECTED_ERROR_CODES.has(error?.response?.data?.code)
                    if (!isLogSenderEndpoint(url) && !expected) {
                        logError('AXIOS', `${method} ${url} -> ${status || 'no response'}: ${error?.message || ''}`, {
                            method,
                            url,
                            status,
                            response_data: error?.response?.data,
                            code: error?.code,
                        })
                    }
                } catch (_) {
                    // ignore logger failures
                }

                if (error.response?.status === 401 && !isRedirectingTo401) {
                    isRedirectingTo401 = true;

                    // Clear user session data
                    localStorage.removeItem('token')
                    localStorage.removeItem('user_id')
                    localStorage.removeItem('user_name')
                    localStorage.removeItem('user_surname')
                    localStorage.removeItem('user_username')
                    localStorage.removeItem('user_email')
                    localStorage.removeItem('user_authenticated')

                    // Clear axios auth header
                    delete window.axios.defaults.headers.common['Authorization']
                    delete window.axios.defaults.headers.common['X-Authorization']
                    delete window.axios.defaults.headers.common['X-User-Id']

                    // Show message to user
                    toast.error('Vaša sesija je istekla ili ste odjavljeni. Molimo prijavite se ponovno.', {
                        position: "top-center",
                        autoClose: 3000,
                        theme: "dark",
                    });

                    // Redirect to login after short delay to show toast
                    setTimeout(() => {
                        window.location.href = '/login';
                    }, 1500);

                    return new Promise(() => {}); // Prevent further error handling
                }

                return Promise.reject(error);
            }
        );
    }

}

export default setApi;